<div class="dialog" fxLayout="column">

  <div mat-dialog-header>
    <div class="dialog-title" fxLayout="row" fxLayoutAlign="space-between end">
      <div fxLayout="row" fxLayoutGap="10px">
        <mat-icon>create</mat-icon>
        <h1 *ngIf="!isAdded">{{'展示詳細情報：編集' | translate}}</h1>
        <h1 *ngIf="!!isAdded">{{'展示詳細情報：追加' | translate}}</h1>
      </div>

      <div fxLayout="row" fxLayoutGap="10px">
        <button *ngIf="userType!=USER_TYPE_USER || (userType==USER_TYPE_USER && isEdit)" mat-raised-button color="primary" (click)="addExhibitDetail()" [disabled]="!exhibitDetailFormGroup.valid">
          <mat-icon>add</mat-icon>
          <span *ngIf="!isAdded">{{'更新' | translate}}</span>
          <span *ngIf="!!isAdded">{{'追加' | translate}}</span>
        </button>
        <button mat-button (click)="onNoClick()">
          <mat-icon>clear</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div mat-dialog-content>
    <form class="form" [formGroup]="exhibitDetailFormGroup">
      <div class="dialog-body" fxLayout="row" fxLayoutGap="24px">

        <div class="dialog-left" fxLayout="column" fxLayoutGap="20px" fxFlex="100%">
          <div fxLayout="row" fxLayoutGap="20px">
            <mat-form-field fxFlex="50%">
              <mat-label floatLabel="always">ID</mat-label>
              <input [ngModel]="inExhibitDetailId" matInput placeholder="ID" id="exhibitDetailId"
                formControlName="exhibitDetailId" maxlength="6"
                (ngModelChange)="inExhibitDetailId = $event.toUpperCase()">
              <mat-error *ngIf="exhibitDetailIdControl.invalid">{{ getErrorMessageToExhibitDetailId() }}</mat-error>
            </mat-form-field>

            <mat-form-field fxFlex="50%">
              <mat-label floatLabel="always">{{'属性' | translate}}</mat-label>
              <mat-select placeholder="{{'属性' | translate}}" id="exhibitDetailAttributeId"
                formControlName="exhibitDetailAttributeId">
                <mat-option [value]=""></mat-option>
                <mat-option *ngFor="let exhibitDetailAttribute of (exhibitDetailAttributes | async)"
                  [value]="exhibitDetailAttribute.attribute_id">
                  {{ exhibitDetailAttribute.attribute_names | multiName:projectLanguages:projectBaseLang }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <mat-form-field>
            <mat-label floatLabel="always">{{'名称' | translate}}</mat-label>
            <input matInput placeholder="{{'名称' | translate}}" id="exhibitDetailNames"
              value="{{ exhibitDetail!.exhibit_detail_names | multiName:projectLanguages:projectBaseLang }}" readonly>
            <button matSuffix mat-stroked-button color="primary" (click)="openExhibitDetailNameDialog()">
              <mat-icon>edit</mat-icon>
            </button>
            <mat-error *ngIf="exhibitDetailNamesControl.invalid">{{ getErrorMessageToExhibitDetailNames() }}</mat-error>
          </mat-form-field>

          <mat-form-field>
            <mat-label floatLabel="always">{{'詳細' | translate}}</mat-label>
            <textarea matInput placeholder="{{'詳細' | translate}}" id="exhibitDetailDescs" rows="3"
              value="{{ exhibitDetail!.exhibit_detail_descs | multiDesc:projectLanguages:projectBaseLang }}"
              readonly></textarea>
            <button matSuffix mat-stroked-button color="primary" (click)="openExhibitDetailDescDialog()">
              <mat-icon>edit</mat-icon>
            </button>
            <mat-error *ngIf="exhibitDetailDescsControl.invalid">{{ getErrorMessageToExhibitDetailDescs() }}</mat-error>
          </mat-form-field>
        </div>

        <div class="dialog-right" fxLayout="column" fxLayoutGap="20px" fxFlex="100%">

          <mat-checkbox formControlName="notOverlapGuide" color="primary">{{'画像の上に詳細概要を重ねない' |
            translate}}</mat-checkbox>

          <div class="exhibit-detail_files">
            <div class="exhibit-detail-files-title" fxLayout="row" fxLayoutAlign="space-between end">
              <span>{{'展示画像ファイル（' | translate}} {{ !!exhibitDetail!.exhibit_detail_files ?
                exhibitDetail!.exhibit_detail_files.length:0 }} {{'件）' | translate}}</span>
              <button mat-stroked-button (click)="openSelectFilesDialog()">
                <mat-icon>add</mat-icon>
                <span>{{'ファイル追加' | translate}}</span>
              </button>
            </div>

            <table>
              <thead>
                <tr>
                  <th>{{'画像' | translate}}</th>
                  <th>{{'名称' | translate}}</th>
                  <th style="width: 100px;">{{'言語' | translate}}</th>
                  <th>{{'削除' | translate}}</th>
                </tr>
              </thead>
              <tbody cdkDropList class="cdk-table" (cdkDropListDropped)="onDrop($event)">
                <tr *ngFor="let exhibitDetailFile of exhibitDetailFiles; let i=index" cdkDrag cdkDragLockAxis="y">
                  <td><img [src]="exhibitDetailFile.download_url" height="40px" width="auto"></td>
                  <td>{{ exhibitDetailFile.file_name }}</td>
                  <td>
                    <mat-select id="lang" [value]="exhibitDetailFile.lang_code"
                      (selectionChange)="changeExhibitDetailFileLang(i, $event)">
                      <ng-container *ngFor="let language of projectLanguages">
                        <mat-option [value]="language.lang_code">
                          {{ currentLang == 'en' ?  (language.lang_name_en ? language.lang_name_en : (language.lang_name | translate)): language.lang_name }}
                        </mat-option>
                      </ng-container>
                    </mat-select>
                  </td>
                  <td>
                    <button mat-stroked-button color="warn" (click)="deleteFiles(i)">
                      <mat-icon>clear</mat-icon>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <mat-checkbox formControlName="useYoutube" color="primary">{{'YouTubeを使用する' | translate}}</mat-checkbox>

          <mat-form-field>
            <mat-label floatLabel="always">{{'Youtube埋め込みコード' | translate}}</mat-label>
            <input matInput placeholder="{{'Youtube埋め込みコード' | translate}}" id="youtubeCodes"
              value="{{ exhibitDetail!.youtube_codes | multiCode:projectLanguages:projectBaseLang }}" readonly>
            <button matSuffix mat-stroked-button color="primary" (click)="openYoutubeCodeDialog()">
              <mat-icon>edit</mat-icon>
            </button>
          </mat-form-field>

          <mat-checkbox formControlName="useExternallink" color="primary">{{'外部リンクを使用する' | translate}}</mat-checkbox>

          <mat-form-field>
            <mat-label floatLabel="always">{{'外部リンク名称' | translate}}</mat-label>
            <input matInput placeholder="{{'外部リンク名称' | translate}}" id="externallinkNames"
              value="{{ exhibitDetail!.externallink_names | multiName:projectLanguages:projectBaseLang }}" readonly>
            <button matSuffix mat-stroked-button color="primary" (click)="openExternallinkNameDialog()">
              <mat-icon>edit</mat-icon>
            </button>
          </mat-form-field>

          <mat-form-field>
            <mat-label floatLabel="always">{{'外部リンクＵＲＬ' | translate}}</mat-label>
            <input matInput placeholder="{{'外部リンクＵＲＬ' | translate}}" id="externallinkUrls"
              value="{{ exhibitDetail!.externallink_urls | multiCode:projectLanguages:projectBaseLang }}" readonly>
            <button matSuffix mat-stroked-button color="primary" (click)="openExternallinkUrlDialog()">
              <mat-icon>edit</mat-icon>
            </button>
          </mat-form-field>
        </div>
      </div>

    </form>
  </div>

</div>